import React from "react";
import { StyledLoader, Container, LoaderText } from "../styled/Loader.styled";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

export default function Loader() {
  return (
    <Container>
      <StyledLoader />
    </Container>
  );
}

export function BackDrop() {
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={true}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}


export function BackDropWithText({ text }) {
  return (
    <Backdrop
    sx={{
      color: "#fff",
      zIndex: (theme) => theme.zIndex.drawer + 1,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    }}
    open={true}
    >
      {/* <CircularProgress color="inherit" /> */}
      <LoaderText>{text}</LoaderText>
    </Backdrop>
  );
}
